module.exports = __webpack_public_path__ + "static/media/family.0e431805.svg";